import * as tf from '@tensorflow/tfjs';
import '@tensorflow/tfjs-backend-webgl';

async function setup() {
    window.tf = tf;
    return tf.setBackend('webgl');
}

export default setup;
